import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { transportistaAllowlistGuard } from './guards/transportista-allowlist';
import { moduleGuard } from './guards/module.guard';
import { roleGuard } from './guards/role.guard';
// HomeComponent lazy-loaded for better initial bundle performance
import { NotFoundComponent } from './common/not-found/not-found.component';
import { SinModulosComponent } from './common/sin-modulos/sin-modulos.component';
import { UsersPageComponent } from './pages/users-page/users-page.component';
import { LiquidacionesPageComponent } from './pages/liquidaciones-page/liquidaciones-page.component';
import { LiquidacionesVdComponent } from './pages/liquidaciones-page/liquidaciones-vd/liquidaciones-vd.component';
import { LiquidacionVdDetalleComponent } from './pages/liquidaciones-page/liquidaciones-vd/liquidacion-vd-detalle/liquidacion-vd-detalle.component';
import { LiquidacionesAgenciaComponent } from './pages/liquidaciones-page/liquidaciones-agencia/liquidaciones-agencia.component';
import { LiquidacionAgenciaDetalleComponent } from './pages/liquidaciones-page/liquidaciones-agencia/liquidacion-agencia-detalle/liquidacion-agencia-detalle.component';
import { OrdenesServicioAgenciaComponent } from './pages/liquidaciones-page/ordenes-servicio-agencia/ordenes-servicio-agencia.component';
import { OrdenesTransporteAgenciaComponent } from './pages/liquidaciones-page/ordenes-transporte-agencia/ordenes-transporte-agencia.component';
import { ControlDusComponent } from './pages/control-dus/control-dus.component';
import { ControlDusPageComponent } from './pages/control-dus/control-dus-page.component';
import { ControlDusDetalleComponent } from './pages/control-dus/control-dus-detalle/control-dus-detalle.component';
import { TorreControlTransportePageComponent } from './pages/torre-control-transporte/torre-control-transporte-page.component';
import { TorreControlTransporteComponent } from './pages/torre-control-transporte/torre-control-transporte.component';
import { EmbeddedModuleComponent } from './pages/integraciones/embedded-module.component';
import { UsersListComponent } from './pages/users-page/users-list/users-list.component';
import { AddUserComponent } from './pages/users-page/add-user/add-user.component';
import { CreateUserPageComponent } from './pages/users-page/create-user-page/create-user-page.component';
import { EditUserPageComponent } from './pages/users-page/edit-user-page/edit-user-page.component';
import { ModulesPageComponent } from './pages/modules-page/modules-page.component';
import { CreateModulePageComponent } from './pages/modules-page/create-module-page/create-module-page.component';
import { EditModulePageComponent } from './pages/modules-page/edit-module-page/edit-module-page.component';
import { ParametersPageComponent } from './pages/parameters-page/parameters-page.component';
import { CreateParameterPageComponent } from './pages/parameters-page/create-parameter-page/create-parameter-page.component';
import { EditParameterPageComponent } from './pages/parameters-page/edit-parameter-page/edit-parameter-page.component';
import { IconsComponent } from './icons/icons.component';
import { MaterialSymbolsComponent } from './icons/material-symbols/material-symbols.component';
import { FeathericonsComponent } from './icons/feathericons/feathericons.component';
import { RemixiconComponent } from './icons/remixicon/remixicon.component';
import { MapsPageComponent } from './pages/maps-page/maps-page.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { SignInComponent } from './authentication/sign-in/sign-in.component';
import { LogoutComponent } from './authentication/logout/logout.component';
import { TransportOrderDetailComponent } from './pages/liquidaciones-page/ordenes-transporte-agencia/detalle-orden-transporte/transport-order-detail.component';
import { ServiceOrderDetailComponent } from './pages/liquidaciones-page/ordenes-servicio-agencia/detalle-orden-servicio/service-order-detail.component';
import { KpiPageComponent } from './pages/kpi-page/kpi-page.component';
import { ReportCategoriesPageComponent } from './pages/report-categories-page/report-categories-page.component';
import { CreateReportCategoryPageComponent } from './pages/report-categories-page/create-report-category-page/create-report-category-page.component';
import { UnderConstructionComponent } from './common/under-construction/under-construction.component';
import { DocumentacionComponent } from './pages/documentacion/documentacion.component';
import { MenuGroupsPageComponent } from './pages/menu-groups-page/menu-groups-page.component';
import { CreateMenuGroupPageComponent } from './pages/menu-groups-page/create-menu-group-page/create-menu-group-page.component';
import { EditMenuGroupPageComponent } from './pages/menu-groups-page/edit-menu-group-page/edit-menu-group-page.component';
import { BookingsModule } from './pages/bookings/bookings.module';
import { ItinerariosModule } from './pages/itinerarios/itinerarios.module';
import { InstructivoEmbarqueModule } from './pages/instructivo-embarque/instructivo-embarque.module';
import { MantenedorAyudasPageComponent } from './pages/mantenedor-ayudas/mantenedor-ayudas-page.component';
import { CreateAyudaPageComponent } from './pages/mantenedor-ayudas/create-ayuda-page/create-ayuda-page.component';
import { EditAyudaPageComponent } from './pages/mantenedor-ayudas/edit-ayuda-page/edit-ayuda-page.component';
import { AyudasComponent } from './pages/ayudas/ayudas.component';

export const routes: Routes = [
    { path: '', component: SignInComponent },
    {
        path: 'home',
        loadComponent: () =>
            import('./pages/home/home.component').then((m) => m.HomeComponent),
        canActivate: [authGuard],
    },
    {
        path: 'users',
        component: UsersPageComponent,
        // P0-02 (punto 3, OPB 10-sep-2026): la administracion de usuarios es
        // solo de admin. El backend responde 403 a operator en /api/v1/users.
        canActivate: [authGuard, roleGuard(['admin'])],
        children: [
            { path: 'users-list', component: UsersListComponent },
            { path: 'add-user', component: AddUserComponent },
            { path: 'create', component: CreateUserPageComponent },
            { path: 'edit/:id', component: EditUserPageComponent },
        ],
    },
    {
        path: 'modules',
        component: ModulesPageComponent,
        canActivate: [authGuard, roleGuard(['admin'])],
        children: [
            { path: 'create', component: CreateModulePageComponent },
            { path: 'edit/:id', component: EditModulePageComponent },
            {
                path: 'menu-groups',
                component: MenuGroupsPageComponent,
                children: [
                    { path: 'create', component: CreateMenuGroupPageComponent },
                    { path: 'edit/:id', component: EditMenuGroupPageComponent },
                ],
            },
            {
                path: 'report-categories',
                component: ReportCategoriesPageComponent,
                children: [
                    {
                        path: 'create',
                        component: CreateReportCategoryPageComponent,
                    },
                ],
            },
        ],
    },
    {
        path: 'parameters',
        component: ParametersPageComponent,
        canActivate: [authGuard, roleGuard(['admin'])],
        children: [
            { path: 'create', component: CreateParameterPageComponent },
            { path: 'edit/:id', component: EditParameterPageComponent },
        ],
    },
    {
        path: 'icons',
        component: IconsComponent,
        canActivate: [authGuard],
        children: [
            { path: '', component: MaterialSymbolsComponent },
            { path: 'feathericons', component: FeathericonsComponent },
            { path: 'remixicon', component: RemixiconComponent },
        ],
    },
    {
        path: 'authentication',
        component: AuthenticationComponent,
        children: [
            { path: '', component: SignInComponent },
            { path: 'logout', component: LogoutComponent },
        ],
    },
    { path: 'maps', component: MapsPageComponent, canActivate: [authGuard] },
    {
        path: 'liquidaciones-vd',
        component: LiquidacionesPageComponent,
        canActivate: [authGuard, moduleGuard('liquidaciones-vd')],
        children: [
            { path: '', component: LiquidacionesVdComponent },
            { path: ':id', component: LiquidacionVdDetalleComponent },
        ],
    },
    {
        path: 'liquidaciones-agencia',
        component: LiquidacionesPageComponent,
        canActivate: [authGuard, moduleGuard('liquidaciones-agencia')],
        children: [
            { path: '', component: LiquidacionesAgenciaComponent },
            { path: ':id', component: LiquidacionAgenciaDetalleComponent },
        ],
    },
    {
        path: 'ordenes-servicio-agencia',
        component: LiquidacionesPageComponent,
        canActivate: [authGuard, moduleGuard('ordenes-servicio')],
        children: [
            { path: '', component: OrdenesServicioAgenciaComponent },
            { path: ':id', component: ServiceOrderDetailComponent },
        ],
    },
    {
        path: 'ordenes-transporte-agencia',
        component: LiquidacionesPageComponent,
        canActivate: [authGuard, moduleGuard('ordenes-transporte')],
        children: [
            { path: '', component: OrdenesTransporteAgenciaComponent },
            { path: ':id', component: TransportOrderDetailComponent },
        ],
    },
    {
        path: 'control-dus',
        component: ControlDusPageComponent,
        canActivate: [authGuard, moduleGuard('control-dus')],
        children: [
            { path: '', component: ControlDusComponent },
            { path: ':nroIE', component: ControlDusDetalleComponent },
            {
                path: ':nroIE/packing-list/:dusNumber',
                loadComponent: () =>
                    import(
                        './pages/control-dus/packing-list/packing-list.component'
                    ).then((m) => m.PackingListComponent),
            },
        ],
    },
    // KPI - Power BI Dashboards (por categoría)
    { path: 'kpi', redirectTo: 'kpi-operativas', pathMatch: 'full' },
    {
        path: 'kpi-operativas',
        component: KpiPageComponent,
        canActivate: [authGuard, moduleGuard('kpi-operativas')],
        data: { category: 'operativo', pageTitle: 'KPIs Operativas' },
    },
    {
        path: 'kpi-finanzas',
        component: KpiPageComponent,
        canActivate: [authGuard, moduleGuard('kpi-finanzas')],
        data: { category: 'financiero', pageTitle: 'KPIs Financieras' },
    },
    {
        path: 'kpi-gerencia',
        component: KpiPageComponent,
        canActivate: [authGuard, moduleGuard('kpi-gerencia')],
        data: { category: 'gerencial', pageTitle: 'KPIs Gerenciales' },
    },
    {
        path: 'torre-control-transporte',
        component: TorreControlTransportePageComponent,
        canActivate: [authGuard, moduleGuard('torreControl')],
        children: [{ path: '', component: TorreControlTransporteComponent }],
    },
    // OPB-263 (D17, 2026-10-08): ruta única genérica para CUALQUIER módulo
    // hijo de un grupo de menú con integration=true (D14) — antes había una
    // entrada hardcodeada por módulo (matriz-tarifaria, contratos,
    // precio-diesel), así que un módulo nuevo creado desde /modules daba 404
    // al no tener ruta propia. Sin roleGuard a propósito: los roles
    // autorizados varían por módulo/grupo (integration_modules.roles), no
    // son fijos — el backend es la autoridad real (403 si el rol no
    // coincide, design.md D1/D5); este guard solo exige sesión iniciada.
    {
        path: 'integraciones/:moduleCode',
        component: EmbeddedModuleComponent,
        canActivate: [authGuard],
    },
    // feat-rol-transportista: inicio del transportista sin ningún módulo asignado
    {
        path: 'sin-modulos',
        component: SinModulosComponent,
        canActivate: [authGuard],
    },
    // Here add new pages component
    {
        path: 'itinerarios',
        loadChildren: () => ItinerariosModule,
        canActivate: [authGuard, moduleGuard('itinerarios')],
    },
    {
        path: 'under-construction',
        component: UnderConstructionComponent,
        canActivate: [authGuard],
    },
    {
        path: 'mantenedor-ayudas',
        component: MantenedorAyudasPageComponent,
        canActivate: [authGuard, roleGuard(['admin'])],
        children: [
            { path: 'create', component: CreateAyudaPageComponent },
            { path: 'edit/:id', component: EditAyudaPageComponent },
        ],
    },
    {
        path: 'ayudas',
        component: AyudasComponent,
        canActivate: [authGuard],
    },
    {
        path: 'docs',
        component: DocumentacionComponent,
        canActivate: [authGuard, roleGuard(['admin'])],
    },
    {
        path: 'docs/:id',
        component: DocumentacionComponent,
        canActivate: [authGuard, roleGuard(['admin'])],
    },
    {
        path: 'bookings',
        loadChildren: () => BookingsModule,
        canActivate: [authGuard],
    },
    {
        path: 'instructivo-embarque',
        loadChildren: () => InstructivoEmbarqueModule,
        canActivate: [authGuard],
    },
    // transportistaAllowlistGuard: un transportista que escribe una URL inexistente
    // vuelve a la Torre de Control; los demás ven el 404 de siempre.
    { path: '**', component: NotFoundComponent, canActivate: [transportistaAllowlistGuard] }, // This line will remain down from the whole pages component list
];
